import React from "react";
import "./SubscriptionCheckout.scss";

import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import { useHistory, useParams } from "react-router";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import SubscriptionStylingProvider from "../../components/SubscriptionStylingProvider/SubscriptionStylingProvider";
import SubscriptionPageWrapper, {
  SubscriptionPageContent,
} from "../../components/SubscriptionPageWrapper/SubscriptionPageWrapper";
import {
  closeSubscriptionPage,
  openSelectPlanScreen,
} from "../../subscriptionFunctions";

const ALLOWED_PLAN_IDS = [
  "plan-indahash-lite",
  "plan-inda-hash-launch",
  "plan-inda-hash-growth",
];

function SubscriptionCheckout() {
  const { activeWorkspaceUuid, identity } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const params = useParams<{ planId: string }>();

  const { planId } = params;

  const history = useHistory();

  if (!planId || !activeWorkspaceUuid) return null;

  if (!ALLOWED_PLAN_IDS.includes(planId)) {
    openSelectPlanScreen(history, activeWorkspaceUuid);
    return null;
  }

  return (
    <SubscriptionPageWrapper>
      <SubscriptionPageContent
        className="subscription-checkout"
        width={1040}
        backButtonFunction={() =>
          closeSubscriptionPage(history, identity?.lastWorkspaceUuid)
        }
        backButtonText={
          <IDHFormattedMessage
            id="ws_back_to_application"
            defaultMessage="Back to application"
          />
        }
      >
        <SubscriptionStylingProvider
          sectionStylingModes={{ checkout: "indahash" }}
        >
          No checkout screen available
        </SubscriptionStylingProvider>

        {/* <Button
          className="change-plan-button"
          size="large"
          variant="white-with-light-grey-border"
          onClick={() => openSelectPlanScreen(history, activeWorkspaceUuid)}
        >
          <EditIcon />
          <IDHFormattedMessage
            id="ws_change_plan"
            defaultMessage="Change plan"
          />
        </Button> */}
      </SubscriptionPageContent>
    </SubscriptionPageWrapper>
  );
}

export default SubscriptionCheckout;
